import { GeoJSONFeature } from 'ol/format/GeoJSON';
import { DeviceStatus, ParametersValues } from '../../models/models';
import { Action, ActionWithPayload, createAction, withMatcher } from '../../utils/reducer/reducer.utils';
import { DEVICE_ACTION_TYPES } from './device.types';

export type GetDeviceStart = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_START, {
        deviceId: string;
        onComplete: (device: GeoJSONFeature) => void;
    }
>;

export type GetDeviceSuccess = Action<
    DEVICE_ACTION_TYPES.GET_DEVICE_SUCCESS
>;

export type GetDeviceFailed = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_FAILED,
    string
>;

export type GetDeviceParamsChartDataStart = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_START, {
        deviceId: string;
        params: string[];
        aggregate: string;
        from_ts: number;
        to_ts: number;
        values_format: string | null;
        loading: boolean;
        onComplete: (data: ParametersValues) => void;
    }
>;

export type GetDeviceParamsChartDataSuccess = Action<
    DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_SUCCESS>;

export type GetDeviceParamsChartDataFailed = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_FAILED,
    string
>;

export type GetDeviceStatusStart = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_START, {
        deviceId: string;
        onComplete: (status: DeviceStatus) => void;
    }
>;

export type GetDeviceStatusSuccess = Action<
    DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_SUCCESS
>;

export type GetDeviceStatusFailed = ActionWithPayload<
    DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_FAILED,
    string
>;

export const getDeviceStart = withMatcher(
    (deviceId: string, onComplete: (device: GeoJSONFeature) => void): GetDeviceStart =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_START, { deviceId, onComplete })
);

export const getDeviceSuccess = withMatcher(
    (): GetDeviceSuccess =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_SUCCESS)
);

export const getDeviceFailed = withMatcher(
    (error: string): GetDeviceFailed =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_FAILED, error)
);

export const getDeviceParamsChartDataStart = withMatcher(
    (deviceId: string, params: string[], aggregate: string, from_ts: number, to_ts: number, values_format: string | null, loading: boolean, onComplete: (data: ParametersValues) => void): GetDeviceParamsChartDataStart =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_START, { deviceId, params, aggregate, from_ts, to_ts, values_format, loading, onComplete })
);

export const getDeviceParamsChartDataSuccess = withMatcher(
    (): GetDeviceParamsChartDataSuccess =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_SUCCESS)
);

export const getDeviceParamsChartDataFailed = withMatcher(
    (error: string): GetDeviceParamsChartDataFailed =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_PARAMS_CHART_DATA_FAILED, error)
);

export const getDeviceStatusStart = withMatcher(
    (deviceId: string, onComplete: (status: DeviceStatus) => void): GetDeviceStatusStart =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_START, { deviceId, onComplete })
);

export const getDeviceStatusSuccess = withMatcher(
    (): GetDeviceStatusSuccess =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_SUCCESS)
);

export const getDeviceStatusFailed = withMatcher(
    (error: string): GetDeviceStatusFailed =>
        createAction(DEVICE_ACTION_TYPES.GET_DEVICE_STATUS_FAILED, error)
);